// reducers/catalog/index.js

import { combineReducers }      from 'redux';
import { categories }           from './categories';
import { categoriesHasErrored } from './categories';
import { categoriesIsLoading }  from './categories';
import { search }               from './search';
import { searchHasErrored }     from './search';
import { searchIsLoading }      from './search';

const categoryReducers = combineReducers({
  categories,
  categoriesHasErrored,
  categoriesIsLoading
});

const searchReducers = combineReducers({
  search,
  searchHasErrored,
  searchIsLoading
});

export default combineReducers({
  categories: categoryReducers,
  search: searchReducers
});